export default {"src":"/_next/static/media/process-check.c8466293.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};